import { getRegion } from 'utils/Region';

export const REGION = getRegion();

export const APA_KEYS = {
  TITLE: 'noticePrivacy_popupTitle_label',
  SUBTITLE: 'noticePrivacy_popupDescription_label',
  CHECKBOX_LABEL: 'noticePrivacy_popupValidate_label',
  TERMS_AND_CONDITIONS: 'noticePrivacy_popupTermsConditions_option_button',
  PRIVACY_POLICY: 'noticePrivacy_popupPrivacyPolicy_option_button',
  CONTINUE: 'noticePrivacy_popupContinue_option_button',
  TERMS_FULL_TEXT: 'tyc_full_text',
  POLICY_FULL_TEXT: 'pp_full_text',
  CHECKBOX_TOOLTIP: 'password_tooltip_checkTermsConditions_label_validation',
  LUF_FULL_TEXT: 'luf_full_text',
};

export const ASSET_KEY = {
  BACKGROUND: 'landing_access_background',
  CLARO_LOGO: 'noticePrivacy_claroVideo_logo',
};

export const PRIVACY_POLICY = 'politicas de privacidad';
export const TERMS_AND_CONDITIONS = 'terminos y condiciones';
export const CONTINUE = 'continuar';

export const METRICS_EVENT = 'privacy_policies';
export const METRICS_METHOD = 'correo electronico';
export const METRICS_SELECTION = new Map([
  [PRIVACY_POLICY, 'politicas'],
  [TERMS_AND_CONDITIONS, 'terminos'],
  [CONTINUE, 'continuar'],
]);

const DISCLAIMER_URL = {
  TERMINOS: 'terminos_y_condiciones',
  POLITICAS: 'politicas_de_privacidad',
  USUARIO_FINAL: 'licencia_usuario_final',
};

export const DISCLAIMER_MAP = new Map([
  [PRIVACY_POLICY, DISCLAIMER_URL.POLITICAS],
  [TERMS_AND_CONDITIONS, DISCLAIMER_URL.TERMINOS],
]);

export const HREF_DISCLAIMER_MAP = new Map([
  [DISCLAIMER_URL.POLITICAS, APA_KEYS.POLICY_FULL_TEXT],
  [DISCLAIMER_URL.TERMINOS, APA_KEYS.TERMS_FULL_TEXT],
  [DISCLAIMER_URL.USUARIO_FINAL, APA_KEYS.LUF_FULL_TEXT],
]);

export const DISCLAIMER_REGEXP = new RegExp(
  `${DISCLAIMER_URL.POLITICAS}|${DISCLAIMER_URL.TERMINOS}|${
    DISCLAIMER_URL.USUARIO_FINAL
  }`,
  'g',
);
